<template>
    <!-- This was previously part of the app-layout component, but we don't have direct access to it anymore -->
    <!-- <template v-if="share" #head>-->
    <!--     <title>{{ socialShareMeta.title }}</title>-->
    <!--     <meta name="title" property="og:title" :content="socialShareMeta.title" />-->
    <!--     <meta name="description" property="og:description" :content="socialShareMeta.description" />-->
    <!--     <meta property="og:url" :content="socialShareMeta.url" />-->
    <!--     <meta property="og:site_name" content="Scorsync" />-->
    <!--     <meta property="og:type" content="website" />-->
    <!--     <meta name="twitter:card" content="summary" />-->
    <!--     <meta name="twitter:site" content="@scorsync" />-->
    <!--     <meta name="twitter:creator" content="@scorsync" />-->
    <!--     <meta name="twitter:title" :content="socialShareMeta.title" />-->

    <!--     <meta-->
    <!--         v-for="image in socialShareMeta.images"-->
    <!--         :key="image"-->
    <!--         name="image"-->
    <!--         property="og:image"-->
    <!--         :content="image"-->
    <!--     />-->
    <!--     <meta v-for="image in socialShareMeta.images" :key="image" name="twitter:image" :content="image" />-->

    <!--     <meta-->
    <!--         v-if="socialShareMeta.images.length === 0"-->
    <!--         name="image"-->
    <!--         property="og:image"-->
    <!--         :content="`${appUrl}/images/scorsync-cover.png`"-->
    <!--     />-->
    <!--     <meta-->
    <!--         v-if="socialShareMeta.images.length === 0"-->
    <!--         name="image"-->
    <!--         property="twitter:image"-->
    <!--         :content="`${appUrl}/images/scorsync-cover.png`"-->
    <!--     />-->

    <!--     <template v-for="(video, index) in socialShareMeta.videos">-->
    <!--         <meta :key="`og:video-${index}`" name="og:video" property="og:video" :content="video" />-->
    <!--         <meta :key="`twitter:player-${index}`" name="twitter:player" :content="video" />-->
    <!--         <meta :key="`og:video:width-${index}`" property="og:video:width" content="1920" />-->
    <!--         <meta :key="`og:video:height-${index}`" property="og:video:height" content="1080" />-->
    <!--         <meta :key="`twitter:video-${index}`" name="twitter:video" :content="video" />-->
    <!--         <meta :key="`twitter:video:stream-${index}`" name="twitter:video:stream" :content="video" />-->
    <!--     </template>-->
    <!-- </template>-->
    <div>
        <v-container>
            <v-row v-for="announcement in meet.announcements" :key="announcement.id">
                <v-col>
                    <v-alert border="top" colored-border type="info" elevation="2">
                        <strong>{{ announcement.title }}</strong>
                        <p v-html="announcement.description"></p>
                    </v-alert>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-card class="mb-3">
                        <v-card-text>
                            <!-- TODO Address :had-finals="hadFinals" -->
                            <meet-header
                                :meet-id="meetId"
                                :latest-result="latestResult"
                                :had-finals="hadFinals"
                                :live-streams="liveStreams"
                                :round="round"
                                no-title
                                show-back-link
                            />
                        </v-card-text>
                    </v-card>

                    <v-card>
                        <v-card-title class="align-start">
                            <div class="flex-column">
                                <div class="font-weight-bold">
                                    <span v-if="$vuetify.breakpoint.xsOnly">
                                        {{ resultCategory.event_short_title }}
                                    </span>
                                    <span v-else>
                                        {{ resultCategory.event_title }}
                                    </span>
                                    <span v-if="$vuetify.breakpoint.xsOnly">
                                        &nbsp;- {{ resultCategory.level_short }}
                                    </span>
                                    <span v-else-if="!meet.is_international">
                                        &nbsp;- {{ resultCategory.level_title }}
                                    </span>
                                </div>

                                <div>
                                    {{ resultCategory.genderLabel(true) }}

                                    <span v-if="!resultCategory.is_elite">
                                        {{ resultCategory.age_group }}
                                    </span>
                                </div>
                            </div>
                            <v-spacer />
                            <div>
                                <div class="text-right">
                                    <v-menu offset-y>
                                        <template #activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" text v-on="on" @click="hideMoreInfoHelp">
                                                <v-icon class="mr-2">info</v-icon>
                                                More Info
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-if="!meet.is_international"
                                                link
                                                @click="showNationalQualification = true"
                                            >
                                                <v-list-item-title>National Qualification</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                v-if="!meet.is_international && canMobilize"
                                                link
                                                @click="showMobility = true"
                                            >
                                                <v-list-item-title>Mobility</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                v-if="
                                                    !meet.is_international && resultCategory.is_elite && isSelectionMeet
                                                "
                                                link
                                                @click="showSelectionScores = true"
                                            >
                                                <v-list-item-title>Selection Scores</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item link @click="showTieBreak = true">
                                                <v-list-item-title>Tie Break</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>

                                    <!-- Loading indicator -->
                                    <div v-if="loadingResults && $vuetify.breakpoint.xsOnly">
                                        <v-progress-circular indeterminate color="primary" size="20" width="3" />
                                    </div>
                                </div>
                                <div v-if="showMoreInfoHelp" class="d-flex justify-end">
                                    <div
                                        class="text-right text-body-1 font-italic"
                                        style="max-width: 150px; word-break: break-word"
                                    >
                                        Tie break, mobility, and qualification scores
                                        <v-icon>mdi-arrow-up-right</v-icon>
                                    </div>
                                </div>
                            </div>
                        </v-card-title>

                        <div
                            v-if="isAdmin && meet.is_international && !['finals', 'final_two'].includes(round)"
                            class="ml-4 d-flex"
                        >
                            <div>
                                <v-switch v-model="editingQualification" label="Edit Qualification" />
                            </div>

                            <div class="mt-4 ml-4">
                                <v-btn v-if="editingQualification" @click="saveQualificationEdits">Save</v-btn>
                            </div>
                        </div>

                        <template v-if="round !== 'start_list'">
                            <div v-if="hasUnofficialResults" class="ml-4 mb-4">
                                <verify-results-control :meet="meet">
                                    <template #default="{ handler }">
                                        <v-chip color="warning" outlined small @click="handler">
                                            <span>Unofficial Results</span>
                                        </v-chip>
                                    </template>
                                </verify-results-control>
                            </div>

                            <div v-else class="ml-4 mb-4">
                                <verify-results-control :meet="meet">
                                    <template #default="{ handler }">
                                        <v-chip color="success" small @click="handler">
                                            <v-icon small class="mr-1">mdi-check-decagram</v-icon>
                                            <span>Official Results</span>
                                        </v-chip>
                                    </template>
                                </verify-results-control>
                            </div>
                        </template>

                        <div v-if="$store.state.entities.meets.verifyingResults === meet.id" class="ml-4 mb-4 d-flex">
                            <portal-target v-if="round === 'prelims'" name="official-results-controls-prelims" />
                            <portal-target v-if="round === 'semi_final'" name="official-results-controls-semi_final" />
                            <portal-target v-if="round === 'finals'" name="official-results-controls-finals" />
                            <portal-target v-if="round === 'final_one'" name="official-results-controls-final_one" />
                            <portal-target v-if="round === 'final_two'" name="official-results-controls-final_two" />
                        </div>

                        <v-tabs v-model="round">
                            <v-tab v-if="hasStartList" href="#start_list" @click="loadStartLists">Start List</v-tab>
                            <v-tab href="#prelims">Qualification</v-tab>
                            <v-tab v-if="hadSemiFinal" href="#semi_final">Q2</v-tab>
                            <v-tab v-if="hadFinals" href="#finals">Final</v-tab>
                            <v-tab v-if="hadFinalOne" href="#final_one">Final One</v-tab>
                            <v-tab v-if="hadFinalTwo" href="#final_two">Final Two</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="round" touchless>
                            <v-tab-item value="start_list">
                                <v-skeleton-loader
                                    v-if="loadingStartLists"
                                    type="table-heading, list-item-three-line"
                                    boilerplate
                                />

                                <v-expansion-panels v-model="panels" focusable multiple>
                                    <v-expansion-panel v-for="flight in startListFlights" :key="flight.id">
                                        <v-expansion-panel-header>
                                            <v-row no-gutters>
                                                <v-col cols="8">
                                                    <span>{{ flight.title }}</span>

                                                    <span v-if="flight.starts_at" class="ml-2">
                                                        <datetime-display
                                                            :datetime="flight.starts_at"
                                                            format="ddd h:mm a"
                                                            :timezone="meet.timezone"
                                                            class="grey--text text--darken-2 font-weight-bold"
                                                        />
                                                    </span>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <start-list
                                                :start-lists="flight.start_lists"
                                                :flight-event="flight.event"
                                            />
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-tab-item>
                            <v-tab-item value="prelims">
                                <round-results
                                    round="prelims"
                                    :loading="loadingResults"
                                    :meet="meet"
                                    :result-category="resultCategory"
                                    :results="results"
                                    :team-qualifiers="teamQualifiers"
                                    :mobilities="mobilities"
                                    :editing-qualification="editingQualification"
                                    @more-info="showTieBreak = true"
                                />
                            </v-tab-item>
                            <v-tab-item v-if="hadSemiFinal" value="semi_final">
                                <round-results
                                    :loading="loadingResults"
                                    :meet="meet"
                                    :result-category="resultCategory"
                                    :results="results"
                                    round="semi_final"
                                />
                            </v-tab-item>
                            <v-tab-item v-if="hadFinals" value="finals">
                                <round-results
                                    :loading="loadingResults"
                                    :meet="meet"
                                    :result-category="resultCategory"
                                    :results="results"
                                    :editing-qualification="editingQualification"
                                    round="finals"
                                />
                            </v-tab-item>
                            <v-tab-item v-if="hadFinalOne" value="final_one">
                                <round-results
                                    :loading="loadingResults"
                                    :meet="meet"
                                    :result-category="resultCategory"
                                    :results="results"
                                    :editing-qualification="editingQualification"
                                    round="final_one"
                                />
                            </v-tab-item>
                            <v-tab-item v-if="hadFinalTwo" value="final_two">
                                <round-results
                                    :loading="loadingResults"
                                    :meet="meet"
                                    :result-category="resultCategory"
                                    :results="results"
                                    :editing-qualification="editingQualification"
                                    round="final_two"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-bottom-sheet v-model="showNationalQualification">
            <qualification-display
                v-if="qualifications.length"
                v-model="highlightQualification"
                :qualifications="qualifications"
                :meet="meet"
            />
        </v-bottom-sheet>

        <v-bottom-sheet v-model="showMobility">
            <mobility-display
                v-if="mobilities.length"
                v-model="highlightMobility"
                :mobilities="mobilities"
                :meet="meet"
            />
        </v-bottom-sheet>

        <v-bottom-sheet v-model="showSelectionScores">
            <selection-score-display :team-qualifiers="teamQualifiers" :result-category="resultCategory" :meet="meet" />
        </v-bottom-sheet>

        <v-bottom-sheet v-model="showTieBreak">
            <v-card elevation="1">
                <v-card-title>Tie Break Rules</v-card-title>
                <v-card-text>
                    <v-simple-table>
                        <template #default>
                            <tbody>
                                <tr v-for="(tieBreakerField, index) in tieBreaker" :key="index">
                                    <td>
                                        {{ tieBreakerField }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-bottom-sheet>

        <v-snackbar v-model="snackbar" bottom>
            <span class="font-weight-bold">{{ snackbarText }}</span>
            <template v-slot:action="{ attrs }">
                <v-btn v-bind="attrs" color="red" text @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import Vue from 'vue';
import numeral from 'numeral';
import ResultCategory from '@/Models/ResultCategory.js';
import Result from '@/Models/Result.js';
import Meet from '@/Models/Meet.js';
import MeetHeader from '@/Components/MeetHeader.vue';
import MobilityDisplay from '@/Components/MobilityDisplay.vue';
import QualificationDisplay from '@/Components/QualificationDisplay.vue';
import PageMixin from '@/Pages/Page.mixin.js';
import RealTimeMixin from '@/Mixins/RealTime.mixin.js';
import RoundResults from '@/Components/Results/RoundResults.vue';
import Flight from '@/Models/Flight.js';
import StartList from '@/Components/StartList.vue';
import DatetimeDisplay from '@/Components/DatetimeDisplay.vue';
import SelectionScoreDisplay from '@/Components/SelectionScoreDisplay.vue';
import User from '@/Models/User.js';
import QueryBuilder from '@/query-builder.js';
import AllAroundResult from '@/Models/AllAroundResult.js';
import VerifyResultsControl from '@/Components/VerifyResultsControl.vue';

const appUrl = import.meta.env.VITE_APP_URL;

export default {
    name: 'ResultCategory',

    components: {
        SelectionScoreDisplay,
        DatetimeDisplay,
        StartList,
        RoundResults,
        QualificationDisplay,
        MobilityDisplay,
        MeetHeader,
        VerifyResultsControl,
    },

    mixins: [PageMixin, RealTimeMixin(5000)],

    provide() {
        return {
            sharedState: {},
        };
    },

    props: {
        meetId: {
            type: Number,
            required: true,
        },

        resultCategoryId: {
            type: Number,
            required: true,
        },

        hasStartList: {
            type: Boolean,
            required: false,
            default: false,
        },

        hadSemiFinal: {
            type: Boolean,
            required: true,
        },

        hadFinals: {
            type: Boolean,
            required: true,
        },

        hadFinalOne: {
            type: Boolean,
            required: true,
        },

        hadFinalTwo: {
            type: Boolean,
            required: true,
        },

        displayRound: {
            required: true,
            validator: (value) => typeof value === 'string' || value === null,
        },

        mobilities: {
            type: Array,
            required: true,
        },

        qualifications: {
            type: Array,
            required: true,
        },

        liveStreams: {
            type: Array,
            required: false,
            default: () => [],
        },

        tieBreaker: {
            required: true,
            validator: (value) => Array.isArray(value) || value === null,
        },

        share: {
            type: Object,
            required: false,
            default: null,
        },

        teamQualifiers: {
            type: Array,
            required: false,
            default: () => [],
        },

        isSelectionMeet: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        round: 'prelims',
        headers: null,
        search: null,
        selectedScores: [],
        highlightMobility: false,
        highlightQualification: false,
        showAllInFinals: false,
        loadingStartLists: false,
        loadingResults: false,
        startListLoaded: false,
        startListFlightIds: [],
        panels: [],
        flightIds: [],
        appUrl,
        showNationalQualification: false,
        showMobility: false,
        showSelectionScores: false,
        showTieBreak: false,
        editingQualification: false,
        showMoreInfoHelp: !localStorage.getItem('hideMoreInfoHelp'),
        verifyingResults: false,
        scoreInterval: null,
        snackbar: false,
        snackbarText: '',
    }),

    computed: {
        debugMode() {
            return this.$store.state.debugMode;
        },

        meet() {
            return Meet.query().with('announcements').find(this.meetId);
        },

        startListFlights() {
            if (!this.startListLoaded) {
                return [];
            }

            return Flight.query()
                .where('meet_id', this.meetId)
                .with('start_lists', (query) => {
                    return query.where('result_category_id', this.resultCategoryId).orderBy('order');
                })
                .with(['start_lists.athlete', 'start_lists.club', 'start_lists.athlete2', 'start_lists.club2'])
                .whereIdIn(this.flightIds)
                .get();
        },

        latestResult() {
            const latestResults = this.results.filter((result) =>
                result.timestamp('updated_at').isSameOrAfter(this.now.clone().subtract(10, 'minutes')),
            );

            return _.first(_.orderBy(latestResults, ['updated_at'], ['desc']));
        },

        resultCategory() {
            return ResultCategory.query().with('meet').find(this.resultCategoryId);
        },

        isAdmin() {
            return User.find(this.$page.props.auth?.user?.id)?.is_admin;
        },

        isAFinalRound() {
            return (
                this.round === 'semi_final' ||
                this.round === 'finals' ||
                this.round === 'final_one' ||
                this.round === 'final_two'
            );
        },

        scoreSortField() {
            let field;

            if (this.round === 'prelims') {
                field = 'prelims_score';
            } else if (
                (this.resultCategory.is_elite && this.meet.elite_new_life_finals) ||
                (!this.resultCategory.is_elite && this.meet.jo_new_life_finals)
            ) {
                field = `${this.round}_score`;
            } else {
                field = 'total_score';
            }

            return field;
        },

        results() {
            let includes;

            if (this.resultCategory.event === 'AA') {
                includes = ['athlete', 'club.country', 'tra_result', 'dmt_result', 'tum_result'];
            } else if (this.resultCategory.event === 'TS') {
                includes = ['athlete', 'athlete2', 'club.country', 'club2.country'];
            } else {
                includes = ['athlete', 'club.country'];
            }

            const model = this.resultCategory.event === 'AA' ? AllAroundResult : Result;

            const query = model
                .query()
                .with(includes)
                .with(this.resultCategory.skill_deductions_key)
                .with(`${this.resultCategory.event_results_key}.video`)
                .where('meet_id', this.meetId)
                .where('category_id', this.resultCategoryId);

            if (this.round === 'prelims') {
                query.orderBy('prelims_rank', 'asc');
            } else {
                query.orderBy(`${this.round}_rank`, 'asc').orderBy('prelims_rank', 'asc');
            }

            return query.get();
        },

        canQualify() {
            if (this.resultCategory.is_elite) {
                return this.meet.elite_qualification_meet;
            }

            return this.meet.jo_qualification_meet && !['1', '2', '3', '4'].includes(this.resultCategory.level);
        },

        canMobilize() {
            return !['1', '2', '3', '4'].includes(this.resultCategory.level) && this.resultCategory.level !== 'SR';
        },

        socialShareMeta() {
            if (!this.share) {
                return null;
            }

            const result = this.results.find((shareableResult) => shareableResult.id === this.share.id);

            if (!result) {
                return null;
            }

            return result.shareableMetadata(this.round);
        },

        hasUnofficialResults() {
            return this.results
                .filter((result) => result[`${this.round}_score`] !== null)
                .some((result) => !result[`${this.round}_marked_official_at`]);
        },
    },

    watch: {
        debugMode() {
            this.startScoreInterval();
        },
    },

    created() {
        this.headers = Result.headers(this.meet, this.resultCategory.event, this.round);

        if (!this.hadSemiFinal && !this.hadFinals && !this.hadFinalOne && !this.hadFinalTwo) {
            _.remove(this.headers, ['value', 'num']);
        }

        this.$echo.channel(ResultCategory.broadcastChannel(this.meetId)).listen('ResultsUpdated', (e) => {
            console.log('ResultsUpdated', e);
            this.onScoreUpdated(e);
        });
    },

    async mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const highlight = urlParams.get('highlight');

        if (highlight) {
            // Ensure the round that is selected
            const result = Result.find(highlight);

            this.round = result.latest_round;

            setTimeout(() => {
                const row = document.getElementById(`result-${highlight}`);

                if (row) {
                    row.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 1000);
        } else {
            this.round = this.displayRound || 'start_list';

            if (this.round === 'start_list') {
                await this.loadStartLists();
            }
        }

        if (this.meet.timestamp('ends_at').isAfter(this.now)) {
            this.startScoreInterval();
        }
    },

    beforeDestroy() {
        this.$echo.leave(ResultCategory.broadcastChannel(this.meetId));
        this.clearScoreInterval();
    },

    methods: {
        numeral,

        startScoreInterval() {
            // Ensure any existing interval is cleared.
            this.clearScoreInterval();

            const timer = this.debugMode ? 5000 : 60000; // 5 seconds or 1 minute

            this.scoreInterval = setInterval(() => {
                this.loadScores();
            }, timer);
        },

        // Clears the current interval timer.
        clearScoreInterval() {
            if (this.scoreInterval) {
                clearInterval(this.scoreInterval);
                this.scoreInterval = null;
            }
        },

        async loadScores() {
            this.loadingResults = true;

            try {
                await this.loadResults();
            } catch (error) {
                this.snackbarText = error.response?.data?.message || error.message || 'Error refreshing scores';
                this.snackbar = true;
            } finally {
                this.loadingResults = false;
            }
        },

        // Method to handle websocket score events.
        onScoreUpdated(e) {
            if (e.resultCategory.id === this.resultCategory.id) {
                // Immediately refresh scores.
                this.loadScores();
                // Restart the interval timer so that the countdown resets.
                this.startScoreInterval();
            }
        },

        loadResults() {
            const query = new QueryBuilder('results')
                .filter('meet_id', this.meetId)
                .filter('category_id', this.resultCategoryId)
                .raw({
                    event: this.resultCategory.event,
                    qualified: 'true',
                    mobilized: 'true',
                    include_changes: true,
                });

            return Result.api().get(query.toUrl());
        },

        selectScore(score) {
            if (this.selectedScores.includes(score.id)) {
                Vue.delete(
                    this.selectedScores,
                    _.findIndex(this.selectedScores, (scoreId) => scoreId === score.id),
                );
            } else {
                this.selectedScores.push(score.id);
            }
        },

        async loadStartLists() {
            if (this.startListLoaded) {
                return;
            }

            this.loadingStartLists = true;

            const { response } = await Flight.api().get(
                `/api/result-category-start-lists/${this.resultCategoryId}?meet_id=${this.meetId}`,
            );

            this.panels = Array.from(Array(response.data.data.length).keys());

            this.flightIds = response.data.data.map((flight) => flight.id);

            this.startListLoaded = true;

            this.loadingStartLists = false;
        },

        saveQualificationEdits() {
            this.$inertia.post(`/meets/${this.meetId}/qualification-edits`, {
                results: this.results,
            });

            this.editingQualification = false;
        },

        hideMoreInfoHelp() {
            this.showMoreInfoHelp = false;
            localStorage.setItem('hideMoreInfoHelp', 'true');
        },
    },
};
</script>
